(ns app.front.view.application.reviews
  (:require [app.domain.application.shared-core :as app-shared]
            [app.front.review-v2.subs :as review-subs]
            [app.front.review-v2.view :as review-view]
            [app.front.ui.content-switcher :as ui-cs]
            [app.front.view.workspace.section :as ws-section]
            [app.front.view.workspace.subs :as ws-subs]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.icons :as i]))


(def submitted-review-states
  #{:process.state/submitted
    :process.state/submission-changes-requested
    :process.state/submission-awaiting-sign-off
    :state.application/submitted
    :state.application/submission-changes-requested
    :state.application/submission-awaiting-sign-off})


(defn- review-step [review]
  (let [state (:review/created-in-state review)]
    (if (submitted-review-states state)
      :process.state/submitted
      :process.state/in-review)))

(defn- reviews-for-step [reviews step]
  (filter #(= step (review-step %)) reviews))

(defn- current-review-step [application]
  (if (= :process.state/submitted
         (app-shared/normalized-review-created-state (or (:process/state application)
                                                         (:domain/state application))))
    :process.state/submitted
    :process.state/in-review))

(defn- review-step-section [{:keys [tr] :as state} step reviews class-name]
  (let [review-step-name (case step
                           :process.state/submitted (tr [:review/step-submitted])
                           :process.state/in-review (tr [:review/step-in-review])
                           (tr [:review/step-unknown]))]
    (when (seq reviews)
      [:div {:class class-name}
       [:h4.font-semibold.mb-2 review-step-name]
       [:div.bx--row
        [:div.bx--col-xs-12
         [review-view/reviews-list-authority (assoc state :reviews reviews)]]]])))

(defn- reviews-tab-content [{:keys [application reviews] :as state} active-tab]
  (let [current-reviews   (reviews-for-step reviews (current-review-step application))
        submitted-reviews (reviews-for-step reviews :process.state/submitted)
        in-review-reviews (reviews-for-step reviews :process.state/in-review)]
    (case active-tab
      :current-step
      [:div.bx--row
       [:div.bx--col-xs-12
        {:key "review-list-authority-current"}
        [review-view/reviews-list-authority (assoc state
                                                   :reviews current-reviews
                                                   :rearrange? true)]]]

      :all-reviews
      [:div
       [review-step-section state :process.state/submitted submitted-reviews "mb-6"]
       [review-step-section state :process.state/in-review in-review-reviews nil]])))

(defn authority-review-v2-section [{:keys [application tr reviews] :as state} reviews-count]
  (let [show-tabs?      (or (and (<sub [::ff/enabled? :feature-flag.id/reviews-in-submitted])
                                 (<sub [::ws-subs/has-feature? :group.feature/reviews-in-submitted]))
                            (seq (reviews-for-step reviews :process.state/submitted)))
        active-tab      (<sub [::review-subs/active-review-tab (:db/id application)])
        edit-permitted? (<sub [:app.front.process/app-signal-permitted? [:process.signal/create-review]])]
    [ws-section/section
     application
     review-subs/section-id

     (assoc
       state
       :heading-button
       (when edit-permitted?
         [cc/button
          {:icon             i/plus
           :icon-description (tr [:review/new "Add new review"])
           :kind             :ghost
           :on-click         #(>evt [::review-subs/toggle-new-review-form])}
          (tr [:review/new "Add new review"])])
       :heading-tag
       reviews-count)

     :reviews
     true

     [review-view/start-new-review-round-modal tr (:db/id application)]

     (when (<sub [::review-subs/review-form-visible?])
       [:div.bx--row
        [:div.bx--col-xs-12
         {:key "review-form"}
         [:h3.text-base.font-semibold.mb-4 (tr [:review/request])]
         [review-view/new-review-form (assoc state
                                             :save-event ::review-subs/new-review
                                             :toggle-form-event ::review-subs/toggle-new-review-form)]]])
     (if show-tabs?
       [:<>
        [:div.mb-4
         ^{:key active-tab}
         [ui-cs/content-switcher
          {:items     [:current-step :all-reviews]
           :current   active-tab
           :on-change #(>evt [::review-subs/set-review-tab %])
           :val->str  (fn [item]
                        (case item
                          :current-step (tr [:review/tab-current-step])
                          :all-reviews (tr [:review/tab-all-reviews])
                          ""))}]]
        [reviews-tab-content state active-tab]]
       [:div.bx--row
        [:div.bx--col-xs-12
         {:key "review-list-authority"}
         [review-view/reviews-list-authority (assoc state :rearrange? edit-permitted?)]]])]))


(defn applicant-review-v2-section [{:keys [tr reviews application] :as state} reviews-count]
  [ws-section/section
   application
   :applicant-review-section
   (assoc
     state
     :heading-tag
     reviews-count)
   :reviews
   true
   [:div.bx--row
    [:div.bx--col-xs-12
     {:key "review-list-applicant"}
     (if (and (<sub [::ff/enabled? :feature-flag.id/applicant-review-history])
              (<sub [::ws-subs/has-feature? :group.feature/detailed-applicant-review-history]))
       [review-view/reviews-list-public-expandable tr reviews]
       [review-view/reviews-list-public tr reviews])]]])

(defn view [{:keys [application workspace] :as state}]
  (let [reviews            (<sub [::review-subs/reviews (:db/id application)])
        reviews-count      (count reviews)
        review-configs     (<sub [::review-subs/ws-review-configs])
        user-is-authority? (->> (<sub [:session/authority-groups])
                                (map :db/id)
                                (some #{(-> workspace :domain/authority-group :db/id)})
                                boolean)
        state              (assoc state :reviews reviews :review-configs review-configs)]
    (when review-configs
      (if (or (<sub [:app.front.process/app-signal-permitted? [:process.signal/create-review]])
              user-is-authority?)
        [authority-review-v2-section state reviews-count]
        (when-not (empty? reviews)
          [applicant-review-v2-section state reviews-count])))))
